import {useQuery} from "@tanstack/react-query";
import {REPORT_ENDPOINTS} from "../../services/network/endpoints";
import {ReportAPI} from "../../services/network/report-api";

/**
 * Хук для получения данных отчета
 * @param reportingWeek Номер недели
 * @param reportingYear Год
 * @param owner ID владельца (для администратора - ID выбранного пользователя, для обычного - ID самого пользователя)
 * @param enabled Флаг, определяющий, нужно ли выполнять запрос
 */
export function useFetchReports(
    reportingWeek?: number, 
    reportingYear?: number, 
    owner?: string | null,
    enabled: boolean = true,
) {

    const {data, error, isLoading} = useQuery({
        queryKey: [REPORT_ENDPOINTS.FETCH, reportingWeek, reportingYear, owner],
        queryFn: () => ReportAPI.fetchReports(
            reportingWeek || 0, 
            reportingYear || 0, 
            owner || null
        ),
        enabled: enabled && Boolean(reportingWeek && reportingYear && (owner !== undefined)  && (owner !== null))
    });

    return {
        reportsData: data?.data,
        reportsError: error,
        reportsIsLoading: isLoading,
    };
}